export const ADFOX_TIMEOUT = 2000;

export const NATIVE_TGB_POSITIONS = [5, 15, 20];
